// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_a4-0";
export var optionCard = "_a4-1";